export const EditTaskSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33329 2.83333C2.02387 2.83333 1.72713 2.95625 1.50833 3.17504C1.28954 3.39383 1.16663 3.69058 1.16663 4V15.6667C1.16663 15.9761 1.28954 16.2728 1.50833 16.4916C1.72713 16.7104 2.02387 16.8333 2.33329 16.8333H14C14.3094 16.8333 14.6061 16.7104 14.8249 16.4916C15.0437 16.2728 15.1666 15.9761 15.1666 15.6667V11.2167C15.1666 10.9405 15.3905 10.7167 15.6666 10.7167C15.9428 10.7167 16.1666 10.9405 16.1666 11.2167V15.6667C16.1666 16.2413 15.9384 16.7924 15.532 17.1987C15.1257 17.6051 14.5746 17.8333 14 17.8333H2.33329C1.75866 17.8333 1.20756 17.6051 0.801228 17.1987C0.394899 16.7924 0.166626 16.2413 0.166626 15.6667V4C0.166626 3.42536 0.394899 2.87426 0.801228 2.46793C1.20756 2.0616 1.75866 1.83333 2.33329 1.83333H6.78329C7.05943 1.83333 7.28329 2.05719 7.28329 2.33333C7.28329 2.60947 7.05943 2.83333 6.78329 2.83333H2.33329Z"
        fill="#373737"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6464 0.313103C13.8417 0.117841 14.1583 0.117841 14.3535 0.313103L17.6868 3.64644C17.7806 3.74021 17.8333 3.86738 17.8333 3.99999C17.8333 4.1326 17.7806 4.25978 17.6868 4.35354L9.35351 12.6869C9.25975 12.7806 9.13257 12.8333 8.99996 12.8333H5.66663C5.39048 12.8333 5.16663 12.6095 5.16663 12.3333V8.99999C5.16663 8.86738 5.2193 8.74021 5.31307 8.64644L13.6464 0.313103ZM6.16663 9.2071V11.8333H8.79285L16.6262 3.99999L14 1.37376L6.16663 9.2071Z"
        fill="#373737"
      />
    </svg>
  );
};
